<template>
  <PageLoader :loading="!loaded">
    <ServicePage
      :provider="provider"
      :service="service"
      :variants="variants"
      :show-menu="showMenu"
      :show-return="showReturn"
    />
  </PageLoader>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { storeToRefs } from "pinia";
import ServicePage from "@/components/pages/service";
import { useServiceBookingStore } from "@/stores/service-booking";
import PageLoader from "@/components/pages/PageLoader";
import { SERVICE_ROUTE_KEY } from "@/components/pages/service/lib";

export default defineComponent({
  components: {
    ServicePage,
    PageLoader,
  },
  setup() {
    definePageMeta({
      layout: "service",
      disableHeaderStick: true,
      noMobileNav: true,
    });

    const store = useServiceBookingStore();
    const route = useRoute();

    const provider = computed(() => String(route.params.provider));
    const service = computed(() => String(route.params.service));
    const variants = computed(() =>
      String(route.query[SERVICE_ROUTE_KEY] || "").split(",")
    );
    if (route.query.reschedule) {
      store.reschedule = String(route.query.reschedule);
    }

    const { loaded } = storeToRefs(store);

    // SEO, meta tags
    // Apply no-crawl for meetings

    const showMenu = computed(() => {
      return route.query.menu !== "false";
    });

    const showReturn = computed(() => {
      return !showMenu.value && route.query.return !== "false";
    });

    return {
      loaded,
      showMenu,
      showReturn,
      provider,
      service,
      variants,
    };
  },
});
</script>
